import { render } from "./GerenciaDesarrollo.vue?vue&type=template&id=47987d91"
import script from "./GerenciaDesarrollo.vue?vue&type=script&lang=js"
export * from "./GerenciaDesarrollo.vue?vue&type=script&lang=js"

import "./GerenciaDesarrollo.vue?vue&type=style&index=0&id=47987d91&lang=scss"

import exportComponent from "G:\\desarrollo\\frontend\\gsobservatorio-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__